import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class BagHistoryService {
	readonly triggerFetchHistory$ = new Subject<void>();
}
